!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t="undefined"!=typeof globalThis?globalThis:t||self).AutosuggestSDK={})}(this,function(t){"use strict";class e{constructor(){this.state={query:"",response:{initialRequestProducts:[],products:[],trendingSearches:[],popularProducts:[],inFields:[],keywordSuggestions:[],promotedSuggestions:[],topSearchQueries:[],prefetchedSearchResults:{}},dom:{inputBox:null,autosuggestionBox:null}}}getState(t){if(!t)return this.state;const e=t.split(".");let s=this.state;for(const t of e)s=s?.[t];return s}updateState(t,e,s=this.state){try{let o=t.split("__"),n=o[0],r=o.slice(1),i={...s};return Object.entries(s).forEach(([t,s])=>{t===n&&(o.length>1?i[t]=this.updateState(r.join("__"),e,s):i[t]=e)}),s===this.state?(this.state=i,this.state):(console.log("StateManager updateState newState",i),i)}catch(t){throw console.error("StateManager updateState error",t),t}}}const s={siteKey:"",apiKey:"",inputBoxConfigs:{searchInput:null,debounceDelay:0,minChars:3},suggestionBoxConfigs:{containerTag:"div",attributes:{class:"unx-autosuggest-box"},template:null},apiConfigs:{apiEndpoint:"https://search.unbxd.io",initialRequest:!1,inFields:{count:2},popularProducts:{count:3,fields:[]},keywordSuggestions:{count:2},topQueries:{count:2},promotedSuggestions:{count:2},trendingSearches:{count:5},search:{prefetch:!1,filterField:""}},onEvent:function({eventType:t}){console.log(`Unbxd Running onEvent with ${t}`)}},o=(t,e)=>{if(!e||0===Object.keys(e).length)return t;if(!t||0===Object.keys(t).length)return e;let s={};return Object.entries(t).forEach(([n,r])=>{s[n]="object"==typeof r&&null!==r?"attributes"===n?{...t[n],...e[n]}:o(t[n],e[n]):e[n]??r}),s};class n{constructor({configs:t}){this.configs=o(s,t)}getConfigs(t){if(!t)return this.configs;const e=t.split(".");let s=this.configs;for(const t of e)s=s?.[t];return s}isRequired(t){return["siteKey","apiKey","searchInput"].includes(t)}updateConfigs(t){this.configs=o(s,t)}}const r="BEFORE_TRENDING_SEARCHES_API_CALL",i="AFTER_TRENDING_SEARCHES_API_CALL",u="BEFORE_AUTOSUGGEST_API_CALL",a="AFTER_AUTOSUGGEST_API_CALL",g="AUTOSUGGEST_QUERY_UPDATED",c="INPUT_FOCUS",h="INPUT_BLUR",l="ERROR";class d{constructor({configurations:t={},setState:e=()=>{},getState:s=()=>{},onAutosuggestionRequest:o=()=>{},onSearchRequest:n=()=>Promise.resolve(),renderSuggestions:r=()=>{},renderPopularProductsOnly:i=()=>{},clearSuggestions:u=()=>{}}){this.configs=t,this.localState={configs:t,inputBox:null,autosuggestionBox:null,lastHoveredSuggestionValue:void 0},this.utilities={setState:e,getState:s,clearSuggestions:u,onAutosuggestionRequest:o,onSearchRequest:n,renderSuggestions:r,renderPopularProductsOnly:i},this.setState=e,this.getState=s,this.onAutosuggestionRequest=o,this.onSearchRequest=n,this.renderSuggestions=r,this.renderPopularProductsOnly=i,this.clearSuggestions=u,this._lastHoveredSuggestionValue=void 0;const a=this.configs?.inputBoxConfigs?.debounceDelay??0;this.debouncedAutosuggestRequest=a>0?function(t,e){let s;return function(...o){clearTimeout(s),s=setTimeout(()=>{t.apply(this,o)},e)}}(t=>this.onAutosuggestionRequest(t),a):null,this.initializeDOM(),this.attachAutosuggestEvents()}initializeDOM(){try{this.inputBox=document.querySelector(this.configs?.inputBoxConfigs?.searchInput)||null,this.autosuggestionBox=this.createAutosuggestionBox(),this.setState("dom__inputBox",this.inputBox),this.setState("dom__autosuggestionBox",this.autosuggestionBox)}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("DOMService initializeDOM error",t)}}createAutosuggestionBox(){try{let t=this.configs?.suggestionBoxConfigs?.containerTag,e={...this.configs?.suggestionBoxConfigs?.attributes||{}},s=document.createElement(t);return Object.entries(e).forEach(([t,e])=>{const o=Array.isArray(e)?e.join(" "):e;s.setAttribute(t,o)}),s}catch(t){return this.configs?.onEvent?.({eventType:l,error:t}),console.error("DOMService createAutosuggestionBox error",t),null}}getEventsToBeAttached(){return[{target:this.inputBox,action:"input",handler:this.onInputChange.bind(this)},{target:this.inputBox,action:"focus",handler:this.onInputFocus.bind(this)},{target:this.inputBox,action:"blur",handler:this.onInputBlur.bind(this)},{target:document,action:"click",handler:this.onDocumentClick.bind(this)},{target:this.autosuggestionBox,action:"mouseover",handler:this.onAutosuggestionBoxHover.bind(this)},{target:this.inputBox,action:"keydown",handler:this.onInputKeyDown.bind(this)}]}attachAutosuggestEvents(){try{this.getEventsToBeAttached().forEach(t=>{let{target:e,action:s,handler:o}=t;e&&e.addEventListener(s,o)})}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("DOMService attachEvents error",t)}}onInputChange(t){try{let e=(t.target.value||"")?.trim();const{query:s}=this.getState()||{};if(e===s)return;this.setState("query",e),this.configs?.onEvent?.({eventType:g,query:e});const{minChars:o}=this.configs?.inputBoxConfigs||{};if(0===e.length||e.length<o)return this.clearSuggestions(),void this.unmountAutosuggestionBox();this.debouncedAutosuggestRequest?this.debouncedAutosuggestRequest({query:e}):this.onAutosuggestionRequest({query:e})}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("onInputChange error",t)}}onInputFocus(t){try{this.configs?.onEvent?.({eventType:c}),this.setState("query",(t.target.value||"")?.trim()),this.renderSuggestions()}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("onInputFocus error",t)}}onInputBlur(){try{this.configs?.onEvent?.({eventType:h}),this.unmountAutosuggestionBox()}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error(t)}}onDocumentClick(t){try{const e=t.target,s=this.inputBox&&this.inputBox.contains(e),o=this.autosuggestionBox&&this.autosuggestionBox.contains(e);s||o||this.autosuggestionBox&&this.unmountAutosuggestionBox()}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("onDocumentClick error",t)}}onInputKeyDown(t){try{"Enter"===t.key&&this.unmountAutosuggestionBox()}catch(t){console.error("onInputKeyDown error",t)}}async onAutosuggestionBoxHover(t){try{const{target:e}=t,s=["infield_suggestion","keyword_suggestion","promoted_suggestion","top_search_query"];if(!e.classList.contains("unx-item")||!s.includes(e.dataset.doctype))return;const o=e.dataset.value;if(o===this._lastHoveredSuggestionValue)return;this._lastHoveredSuggestionValue=o;const n=this.getState("response.prefetchedSearchResults")||{},r=this.configs?.apiConfigs?.search?.prefetch??!1;if(void 0!==n[o])return this.setState("response__popularProducts",n[o]??[]),void this.renderPopularProductsOnly();if(!r){const t=o.indexOf(":"),e=t>=0?o.slice(0,t):o,s=t>=0?o.slice(t+1):null;await this.onSearchRequest({query:e,filters:s?[s]:[]})}const i=this.getState("response.prefetchedSearchResults")||{};this.setState("response__popularProducts",i[o]??[]),this.renderPopularProductsOnly()}catch(t){console.error("onAutosuggestionBoxHover error",t)}}updateSuggestionBoxHTML(t=""){try{this.autosuggestionBox.innerHTML=t}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("updateSuggestionBoxHTML error",t)}}updatePopularProductsSection(t=""){try{const e=this.autosuggestionBox?.querySelector(".unx-popular-products");e&&(e.innerHTML=t)}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("updatePopularProductsSection error",t)}}mountAutosuggestionBox(){try{""!==this.autosuggestionBox?.innerHTML?.trim()?this.inputBox.after(this.autosuggestionBox):this.unmountAutosuggestionBox()}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("mountAutosuggestionBox error",t)}}unmountAutosuggestionBox(){try{this.autosuggestionBox.remove()}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("unmountAutosuggestionBox error",t)}}}class p{constructor({configurations:t,setState:e,getState:s}){this.configs=t,this.setState=e,this.getState=s||(()=>({})),this.fireInitialRequest()}fireInitialRequest(){const t=this.configs?.apiConfigs?.initialRequest,e=this.configs?.apiConfigs?.trendingSearches?.count;t&&this.fireAutosuggestRequest({query:"*",initialCall:!0}),e>0&&this.fireTrendingSearchesRequest()}buildAutosuggestURL({query:t}){try{const{siteKey:e,apiKey:s,apiConfigs:{apiEndpoint:o,inFields:n,popularProducts:r,keywordSuggestions:i,topQueries:u,promotedSuggestions:a}={}}=this.configs||{};let g=new URL(`${o}/`);return g+=`${s}/${e}/autosuggest?q=${t}&version=V2&inFields.count=${n?.count}&keywordSuggestions.count=${i?.count}&popularProducts.count=${r?.count}`+(r?.fields?.length>0?`&popularProducts.fields=${r.fields.join(",")}`:"")+`&topQueries.count=${u?.count}`+`&promotedSuggestions.count=${a?.count}`,g}catch(t){throw console.error("APIService buildAutosuggestURL error",t),t}}buildTrendingSearchesURL(){try{const{siteKey:t,apiKey:e,apiConfigs:{apiEndpoint:s}={}}=this.configs||{};return new URL(`${s}/${e}/${t}/autosuggest?trending-queries=true&q=*`)}catch(t){throw console.error("APIService buildTrendingSearchesURL error",t),t}}buildSearchUrl({query:t,filter:e=""}){const{siteKey:s,apiKey:o,apiConfigs:{popularProducts:n}}=this.configs||{},r=`https://search.unbxd.io/${o}/${s}/search?q=${encodeURIComponent(t)}&rows=${n?.count}&indent=off&facet=off&analytics=false&redirect=false${n?.fields?.length>0?`&fields=${n.fields.join(",")}`:""}`;return e?`${r}& filter=${encodeURIComponent(e)} `:r}async request(t="AUTOSUGGEST",e={}){try{let s="SEARCH"===t?this.buildSearchUrl(e):"TRENDING_SEARCHES"===t?this.buildTrendingSearchesURL():this.buildAutosuggestURL(e);const o=await fetch(s,{method:"GET"});return await o.json()}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("Unbxd Autosuggest APIService request error",t)}}async fireTrendingSearchesRequest(){try{if(this.configs?.apiConfigs?.trendingSearches?.count<=0)return;this.configs?.onEvent?.({eventType:r});const t=await this.request("TRENDING_SEARCHES");if(this.configs?.onEvent?.({eventType:i}),t?.response?.products){const e=this.configs?.apiConfigs?.trendingSearches?.count;this.setState("response__trendingSearches",t.response.products.slice(0,e))}}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("setupTrendingSearches error",t)}}async fireAutosuggestRequest({query:t,initialCall:e=!1}){try{this.configs?.onEvent?.({eventType:u,query:t});const s=await this.request("AUTOSUGGEST",{query:t})||{};if(this.configs?.onEvent?.({eventType:a,query:t}),s?.response?.products)if(e)this.setState("response__initialRequestProducts",s?.response?.products||[]);else{const t=(t=>{try{let e={};return(Array.isArray(t)?t:[]).forEach(t=>{e[t?.doctype]?e[t?.doctype].push(t):e[t?.doctype]=[t]}),e}catch(t){return console.error("getSortedProducts error",t),{}}})(s?.response?.products);this.setState("response__products",s?.response?.products),this.setState("response__popularProducts",t?.POPULAR_PRODUCTS),this.setState("response__inFields",t?.IN_FIELD),this.setState("response__keywordSuggestions",t?.KEYWORD_SUGGESTION),this.setState("response__promotedSuggestions",t?.PROMOTED_SUGGESTION),this.setState("response__topSearchQueries",t?.TOP_SEARCH_QUERIES)}}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("setupAutosuggest error",t)}}async fireSearchRequest({query:t,filters:e=[]}){try{const s=await this.request("SEARCH",{query:t}),o={};if(o[t]=s.response.products,e.length>0){const s=this.configs?.apiConfigs?.search?.filterField,n=e.map(e=>this.request("SEARCH",{query:t,filter:`${s}: "${e}"`})),r=await Promise.all(n),i={...o};r.forEach((s,o)=>{i[`${t}:${e[o]} `]=s.response.products}),this.setState("response__prefetchedSearchResults",{...this.getState("response.prefetchedSearchResults"),...i})}this.setState("response__prefetchedSearchResults",{...this.getState("response.prefetchedSearchResults"),...o})}catch(t){this.configs?.onEvent?.({eventType:l,error:t}),console.error("fireSearchRequest error",t)}}}function S({IN_FIELD:t=[]}){if(0===t.length)return"";return`<div class="unx-infield-suggestions">${t.map(t=>{const e=t[this.configurations.apiConfigs.search.filterField+"_in"];let s="";return e?.length>0&&(s=`${e.map(e=>`<span class="unx-item" data-doctype="infield_suggestion" data-value="${t}:${e}">In ${e}</span>`).join("\n")}`),`<div class="unx-item unx-infield-suggestion" data-doctype="infield_suggestion" data-value="${t.autosuggest}">${t.autosuggest}${s?" "+s:""}</div>`}).join("")}</div>`}function f({KEYWORD_SUGGESTION:t=[]}){if(0===t.length)return"";return`<div class="unx-keyword-suggestions">${t.map(t=>`<div class="unx-item unx-keyword-suggestion" data-doctype="keyword_suggestion" data-value="${t.autosuggest}">${t.autosuggest}</div>`).join("")}</div>`}function y({POPULAR_PRODUCTS:t=[]}){if(0===t.length)return"";return`<div class="unx-popular-products">${t.map(t=>`<div class="unx-item unx-popular-product"><img src="${t.imageUrl}"/><div>${t.title}</div><div>${t.price}</div></div>`).join("")}</div>`}function v({PROMOTED_SUGGESTIONS:t=[]}){if(0===t.length)return"";return`<div class="unx-promoted-suggestions">${t.map(t=>`<div class="unx-item unx-promoted-suggestion" data-doctype="promoted_suggestion" data-value="${t.autosuggest}">${t.autosuggest}</div>`).join("")}</div>`}function m({TOP_SEARCHES:t=[]}){if(0===t.length)return"";return`<div class="unx-top-search-queries">${t.map(t=>`<div class="unx-item unx-top-search-query" data-doctype="top_search_query" data-value="${t.autosuggest}">${t.autosuggest}</div>`).join("")}</div>`}function E({TRENDING_SEARCHES:t=[]}){if(0===t.length)return"";return`<div class="unx-trending-searches">${t.map(t=>`<div class="unx-item unx-trending-search">${t.autosuggest}</div>`).join("")}</div>`}class T{constructor({configurations:t,getState:e}){this.configurations=t,this.getState=e,this.templates={popularProducts:y,inFields:S,keywordSuggestions:f,promotedSuggestions:v,topSearchQueries:m,trendingSearches:E},this.templates.autosuggestionBox=this.configurations?.suggestionBoxConfigs?.template?.bind(this)||this.AutosuggestionBoxTemplate.bind(this)}getTemplate(t){return this.templates[t]}AutosuggestionBoxTemplate(){try{const{query:t,response:{trendingSearches:e=[],popularProducts:s=[],keywordSuggestions:o=[],promotedSuggestions:n=[],topSearchQueries:r=[],inFields:i=[],products:u=[]}={}}=this.getState()||{};if((!t||0==t.trim().length)&&e?.length>0){return this.getTemplate("trendingSearches").call(this,{TRENDING_SEARCHES:e})}const a=s?.length>0?this.getTemplate("popularProducts")({POPULAR_PRODUCTS:s}):"",g=i?.length>0?this.getTemplate("inFields").call(this,{IN_FIELD:i}):"",c=o?.length>0?this.getTemplate("keywordSuggestions")({KEYWORD_SUGGESTION:o}):"",h=n?.length>0?this.getTemplate("promotedSuggestions")({PROMOTED_SUGGESTIONS:n}):"",l=r?.length>0?this.getTemplate("topSearchQueries")({TOP_SEARCHES:r}):"";return`${a}<div class="unx-suggestions">${g}${c}${h}${l}</div>`}catch(t){return console.error("TemplateService AutosuggestionBoxTemplate error",t),""}}constructTrendingSearchesTemplate(){try{const t=this.getState(),{response:{trendingSearches:e}={}}=t||{};return this.getTemplate("trendingSearches").call(this,{TRENDING_SEARCHES:e})}catch(t){return console.error("TemplateService constructTrendingSearchesTemplate error",t),""}}}t.Autosuggest=class{constructor(t){try{this.stateManager=new e,this.configManager=new n({configs:t});const s=this.configManager.getConfigs();this.apiService=new p({configurations:s,setState:this.stateManager.updateState.bind(this.stateManager),getState:this.stateManager.getState.bind(this.stateManager)}),this.templateService=new T({configurations:s,getState:this.stateManager.getState.bind(this.stateManager)}),this.domService=new d({configurations:s,getState:this.stateManager.getState.bind(this.stateManager),setState:this.stateManager.updateState.bind(this.stateManager),onAutosuggestionRequest:this.setupAutosuggestion.bind(this),onSearchRequest:this.fireSearchOnHover.bind(this),renderSuggestions:this.renderSuggestions.bind(this),renderPopularProductsOnly:this.renderPopularProductsOnly.bind(this),clearSuggestions:this.clearSuggestions.bind(this)})}catch(t){console.error("Autosuggest constructor error",t)}}fireSearchOnHover({query:t,filters:e=[]}){return this.apiService.fireSearchRequest({query:t,filters:e})}async setupAutosuggestion({query:t}){try{if(await this.apiService.fireAutosuggestRequest({query:t}),this.renderSuggestions(),this.configManager.getConfigs("apiConfigs.search.prefetch")){const{response:{inFields:t=[],keywordSuggestions:e=[],promotedSuggestions:s=[],topSearchQueries:o=[]}={}}=this.stateManager.getState()||{};[...t,...e,...s,...o].map(t=>{const{autosuggest:e,[this.configManager.getConfigs("apiConfigs.search.filterField")+"_in"]:s}=t;this.apiService.fireSearchRequest({query:e,...s?{filters:s}:{}})})}}catch(t){console.error("handleAutosuggestRequest error",t)}}renderSuggestions(){try{const{query:t="",response:{trendingSearches:e=[],initialRequestProducts:s=[],products:o=[]}={}}=this.stateManager.getState(),n=!t||0===t.trim().length;if(n&&0===e?.length&&0===s?.length||t?.length>0&&(o?.length??0)<=0)return void this.domService.unmountAutosuggestionBox();const r=this.templateService.getTemplate("autosuggestionBox")(this.stateManager.getState());this.domService.updateSuggestionBoxHTML(r),this.domService.mountAutosuggestionBox()}catch(t){console.error("Autosuggest renderSuggestions error",t)}}renderPopularProductsOnly(){try{const{response:{popularProducts:t=[]}={}}=this.stateManager.getState()||{},e=this.templateService.getTemplate("popularProducts")({POPULAR_PRODUCTS:t});this.domService.updatePopularProductsSection(e)}catch(t){console.error("Autosuggest renderPopularProductsOnly error",t)}}clearSuggestions(){try{this.stateManager.updateState("response__products",[]),this.stateManager.updateState("response__popularProducts",[]),this.stateManager.updateState("response__inFields",[]),this.stateManager.updateState("response__keywordSuggestions",[]),this.stateManager.updateState("response__promotedSuggestions",[]),this.stateManager.updateState("response__topSearchQueries",[])}catch(t){console.error("Autosuggest clearSuggestions error",t)}}}});

function getSiteName(){
    return "ss-unbxd-aapac-prod-bigPharmacy69661758605295";
}

function getApiKey(){
    
    return "ca1a93d9131c62380bdae38cbf73232c";
}
function getSearchInputSelector() {
    let active = document.querySelector('input[name="q"][type="search"][' + activeInputAttr + ']');
    if (active) return 'input[name="q"][type="search"][' + activeInputAttr + ']';
    return 'input[name="q"][type="search"]';
}

function escapeHtml(value) {
    if (typeof value !== "string") return value || "";
    let div = document.createElement("div");
    div.textContent = value;
    return div.innerHTML;
}

function getAutosuggestConstructor() {
    if (typeof window !== "undefined") {
        if (typeof window.Autosuggest === "function") return window.Autosuggest;
        if (window.AutosuggestSDK && typeof window.AutosuggestSDK.Autosuggest === "function") {
            return window.AutosuggestSDK.Autosuggest;
        }
    }
    return null;
}

function getImageUrl(imageUrl) {
    if (Array.isArray(imageUrl)) return imageUrl[0] || "";
    return imageUrl || "";
}

function formatPrice(raw) {
    if (raw == null || raw === "") return "";
    let numeric = parseFloat(raw);
    if (isNaN(numeric)) return "RM " + raw;
    return "RM " + numeric.toFixed(2);
}

function getProductPrices(product) {
    let price = product.price ?? product.sale_price ?? product.highestFinalPrice ??
        (Array.isArray(product.variants) && product.variants[0] ? product.variants[0].price : null);
    let compareAt = product.compareAtPrice ?? product.compare_at_price ?? product.compare_at_price_min ?? null;

    let formattedPrice = formatPrice(price);
    let formattedCompare = formatPrice(compareAt);

    let isOnSale = formattedCompare && formattedPrice &&
        parseFloat(compareAt) > parseFloat(price);

    return { price: formattedPrice, compareAt: isOnSale ? formattedCompare : "" };
}

function buildProductsHtml(products, srcQuery) {
    if (!Array.isArray(products) || products.length === 0) return "";
    return products
        .map(function (product, index) {
            let title = escapeHtml(product.title || "");
            let uniqueId = product.uniqueId || "";
            let productUrl = product.productUrl || "/products/" + uniqueId;
            let imageUrl = getImageUrl(product.imageUrl);
            let prices = getProductPrices(product);
            let prank = index + 1;
            let analyticsAttrs = ' data-doctype="POPULAR_PRODUCTS"' +
                ' data-prank="' + prank + '"' +
                ' data-uniqueid="' + escapeHtml(uniqueId) + '"' +
                ' data-title="' + title + '"';
            if (srcQuery) {
                analyticsAttrs += ' data-srcquery="' + escapeHtml(srcQuery) + '"';
            }
            let priceHtml = "";
            if (prices.price) {
                let onSaleClass = prices.compareAt ? " price--on-sale" : "";
                priceHtml =
                    '<div class="price' + onSaleClass + '">' +
                        '<div class="price__container">' +
                            '<div class="price__regular">' +
                                '<span class="price-item price-item--regular">' + prices.price + '</span>' +
                            '</div>' +
                            (prices.compareAt ?
                                '<div class="price__sale">' +
                                    '<span class="price-item price-item--sale">' + prices.price + '</span> ' +
                                    '<s class="price-item price-item--regular">' + prices.compareAt + '</s>' +
                                '</div>'
                            : '') +
                        '</div>' +
                    '</div>';
            }
            return (
                '<li class="predictive-search__list-item" role="option" aria-selected="false"' + analyticsAttrs + '>' +
                    '<a href="' + productUrl + '" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">' +
                        '<img class="predictive-search__image" src="' + imageUrl + '" alt="' + title + '" width="50" loading="lazy" />' +
                        '<div class="predictive-search__item-content">' +
                            '<p class="predictive-search__item-heading h5">' + title + '</p>' +
                            priceHtml +
                        '</div>' +
                    '</a>' +
                '</li>'
            );
        })
        .join("");
}

function buildSuggestionsHtml(items) {
    if (!Array.isArray(items) || items.length === 0) return "";
    return items
        .map(function (item, index) {
            let raw = item.autosuggest || item.value || item.query || "";
            let text = escapeHtml(raw);
            if (!text) return "";
            let doctype = item.doctype === "KEYWORD_SUGGESTION" ? "keyword_suggestion"
                : item.doctype === "TOP_SEARCH_QUERIES" ? "top_search_query"
                : item.doctype === "PROMOTED_SUGGESTION" ? "promoted_suggestion"
                : item.doctype === "IN_FIELD" ? "infield_suggestion"
                : "keyword_suggestion";
            let upperDoctype = item.doctype || "KEYWORD_SUGGESTION";
            let prank = index + 1;
            let analyticsAttrs = ' data-analytics-doctype="' + upperDoctype + '"' +
                ' data-prank="' + prank + '"' +
                ' data-analytics-value="' + escapeHtml(raw) + '"';
            return (
                '<li class="predictive-search__list-item unx-item" role="option" aria-selected="false" ' +
                    'data-doctype="' + doctype + '" data-value="' + escapeHtml(raw) + '"' + analyticsAttrs + '>' +
                    '<a href="/search?q=' + encodeURIComponent(raw) + '" ' +
                        'class="predictive-search__item unx-item link link--text" tabindex="-1" ' +
                        'data-doctype="' + doctype + '" data-value="' + escapeHtml(raw) + '">' +
                        '<div class="predictive-search__item-content predictive-search__item-content--centered unx-item" ' +
                            'data-doctype="' + doctype + '" data-value="' + escapeHtml(raw) + '">' +
                            '<p class="predictive-search__item-heading h5 unx-item" ' +
                                'data-doctype="' + doctype + '" data-value="' + escapeHtml(raw) + '">' + text + '</p>' +
                        '</div>' +
                    '</a>' +
                '</li>'
            );
        })
        .join("");
}

function buildSearchForHtml(query) {
    if (!query || !query.trim()) return "";
    let escaped = escapeHtml(query);
    return (
        '<div class="predictive-search__search-for-button">' +
            '<a href="/search?q=' + encodeURIComponent(query) + '" ' +
                'class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow" ' +
                'tabindex="-1">' +
                '<span>Search for \u201c' + escaped + '\u201d</span>' +
                '<span class="svg-wrapper">' +
                    '<svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg">' +
                        '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor" />' +
                    '</svg>' +
                '</span>' +
            '</a>' +
        '</div>'
    );
}

function buildTemplate(state) {
    let query = (state && state.query) || "";
    let response = (state && state.response) || {};
    let trendingSearches = response.trendingSearches || [];
    let topSearchQueries = response.topSearchQueries || [];
    let keywordSuggestions = response.keywordSuggestions || [];
    let promotedSuggestions = response.promotedSuggestions || [];
    let popularProducts = response.popularProducts || [];
    let inFields = response.inFields || [];

    let suggestions, products;

    if (!query.trim()) {
        suggestions = trendingSearches.length ? trendingSearches
            : topSearchQueries.length ? topSearchQueries : [] || keywordSuggestions.length ? keywordSuggestions : [];
        products = popularProducts;
    } else {
        let allSuggestions = [];
        if (inFields.length) allSuggestions = allSuggestions.concat(inFields);
        if (keywordSuggestions.length) allSuggestions = allSuggestions.concat(keywordSuggestions);
        if (promotedSuggestions.length) allSuggestions = allSuggestions.concat(promotedSuggestions);
        if (topSearchQueries.length) allSuggestions = allSuggestions.concat(topSearchQueries);
        if (!allSuggestions.length) allSuggestions = trendingSearches;
        suggestions = allSuggestions.slice(0, 8);
        products = popularProducts;
    }

    let suggestionsHtml = buildSuggestionsHtml(suggestions);
    let productsHtmlContent = buildProductsHtml(products, query.trim() || undefined);

    let suggestionsCol = '';
    if (suggestionsHtml) {
        suggestionsCol =
            '<div class="predictive-search__result-group">' +
                '<div>' +
                    '<h2 class="predictive-search__heading text-body caption-with-letter-spacing">Suggestions</h2>' +
                    '<ul class="predictive-search__results-list list-unstyled" role="group">' +
                        suggestionsHtml +
                    '</ul>' +
                '</div>' +
            '</div>';
    }

    let productsCol = '';
    if (productsHtmlContent) {
        productsCol =
            '<div class="predictive-search__result-group unx-popular-products">' +
                '<div>' +
                    '<h2 class="predictive-search__heading text-body caption-with-letter-spacing">Products</h2>' +
                    '<ul class="predictive-search__results-list list-unstyled" role="group">' +
                        productsHtmlContent +
                    '</ul>' +
                '</div>' +
            '</div>';
    }

    if (!suggestionsCol && !productsCol) return '';

    let searchFor = buildSearchForHtml(query.trim());

    return (
        '<div class="predictive-search__results-groups-wrapper">' +
            suggestionsCol +
            productsCol +
        '</div>' +
        searchFor
    );
}

let isAutosuggestInitialized = false;
let autosuggestBoundInput = null;

let lastFocusTimeGlobal = 0;
let activeInputAttr = "data-unbxd-as-active";

function initAutosuggest() {
    if (isAutosuggestInitialized) return true;

    let AutosuggestCtor = getAutosuggestConstructor();
    if (!AutosuggestCtor) {
        console.warn("[Unbxd Autosuggest] SDK not loaded yet");
        return false;
    }

    let searchInput = getSearchInputSelector();
    if (!document.querySelector(searchInput)) {
        return false;
    }

    let autosuggest = new AutosuggestCtor({
        siteKey: getSiteName(),
        apiKey: getApiKey(),
        inputBoxConfigs: {
            searchInput: searchInput,
            debounceDelay: 300,
            minChars: 2,
        },
        suggestionBoxConfigs: {
            containerTag: "div",
            attributes: { class: "unx-autosuggest-box" },
            template: buildTemplate,
        },
        apiConfigs: {
            apiEndpoint: "https://search.unbxd.io",
            initialRequest: true,
            inFields: { count: 2 },
            popularProducts: {
                count: 5,
                fields: ["productUrl", "title", "uniqueId", "imageUrl", "price", "sale_price", "compareAtPrice", "compare_at_price", "compare_at_price_min", "autosuggest", "doctype"],
            },
            keywordSuggestions: { count: 6 },
            topQueries: { count: 6 },
            promotedSuggestions: { count: 2 },
            trendingSearches: { count: 6 },
            search: { prefetch: false, filterField: "" },
        },
        onEvent: function (evt) {
            if (evt.eventType === "ERROR") {
                console.error("[Unbxd Autosuggest] Error:", evt.error);
            }
        },
    });

    let initialDataReady = false;

    let customRenderSuggestions = function () {
        let state = autosuggest.stateManager.getState() || {};
        let response = state.response || {};
        let query = state.query || "";
        let hasQuery = query.trim().length > 0;
        let ip = response.initialRequestProducts;
        let hasInitial = Array.isArray(ip) ? ip.length > 0
            : (ip && typeof ip === "object" && Object.values(ip).some(function (arr) { return Array.isArray(arr) && arr.length > 0; }));
        let hasSuggestions = (response.keywordSuggestions || []).length > 0
            || (response.topSearchQueries || []).length > 0
            || (response.trendingSearches || []).length > 0
            || (response.promotedSuggestions || []).length > 0
            || (response.popularProducts || []).length > 0;

        if (hasInitial) initialDataReady = true;

        if (!hasQuery && !hasInitial && !hasSuggestions) {
            if (!initialDataReady) {
                return;
            }
            autosuggest.domService.unmountAutosuggestionBox();
            return;
        }

        if (!hasQuery && hasInitial && (response.popularProducts || []).length === 0) {
            if (Array.isArray(ip)) {
                let sorted = {};
                ip.forEach(function (item) {
                    let dt = item.doctype || "OTHER";
                    if (!sorted[dt]) sorted[dt] = [];
                    sorted[dt].push(item);
                });
                autosuggest.stateManager.updateState("response__popularProducts", sorted["POPULAR_PRODUCTS"] || []);
                autosuggest.stateManager.updateState("response__topSearchQueries", sorted["TOP_SEARCH_QUERIES"] || []);
                autosuggest.stateManager.updateState("response__keywordSuggestions", sorted["KEYWORD_SUGGESTION"] || []);
                autosuggest.stateManager.updateState("response__promotedSuggestions", sorted["PROMOTED_SUGGESTION"] || []);
                autosuggest.stateManager.updateState("response__inFields", sorted["IN_FIELD"] || []);
            } else {
                autosuggest.stateManager.updateState("response__popularProducts", ip.popularProducts || []);
                autosuggest.stateManager.updateState("response__topSearchQueries", ip.topSearchQueries || []);
                autosuggest.stateManager.updateState("response__keywordSuggestions", ip.keywordSuggestions || []);
                autosuggest.stateManager.updateState("response__trendingSearches", ip.trendingSearches || []);
                autosuggest.stateManager.updateState("response__promotedSuggestions", ip.promotedSuggestions || []);
                autosuggest.stateManager.updateState("response__inFields", ip.inFields || []);
            }
        }

        let html = autosuggest.templateService.getTemplate("autosuggestionBox")(autosuggest.stateManager.getState());
        autosuggest.domService.updateSuggestionBoxHTML(html);
        autosuggest.domService.mountAutosuggestionBox();
    };
    autosuggest.renderSuggestions = customRenderSuggestions;
    autosuggest.domService.renderSuggestions = customRenderSuggestions;
    autosuggest.domService.utilities.renderSuggestions = customRenderSuggestions;

    let customRenderPopularProductsOnly = function () {
        let state = autosuggest.stateManager.getState() || {};
        let products = (state.response && state.response.popularProducts) || [];
        if (products.length === 0) return;
        let container = autosuggest.domService.autosuggestionBox;
        if (!container) return;
        let productsList = container.querySelector(".unx-popular-products .predictive-search__results-list");
        if (!productsList) return;
        let srcQuery = state.query || "";
        productsList.innerHTML = buildProductsHtml(products, srcQuery);
    };
    autosuggest.renderPopularProductsOnly = customRenderPopularProductsOnly;
    autosuggest.domService.renderPopularProductsOnly = customRenderPopularProductsOnly;

    autosuggest.domService.inputBox.addEventListener("focus", function () {
        lastFocusTimeGlobal = Date.now();
    });

    let currentNavIndex = -1;
    let originalInputValue = "";

    function getNavItems() {
        let box = document.querySelector(".unx-autosuggest-box");
        if (!box) return [];
        return Array.from(box.querySelectorAll("li.predictive-search__list-item"));
    }

    function applyNavActive(index, items) {
        items.forEach(function (item, i) {
            if (i === index) {
                item.setAttribute("aria-selected", "true");
                item.classList.add("unx-nav-active");
                let value = item.getAttribute("data-value");
                if (value) {
                    autosuggest.domService.inputBox.value = value;
                }
            } else {
                item.setAttribute("aria-selected", "false");
                item.classList.remove("unx-nav-active");
            }
        });
    }

    function clearNavActive(items) {
        (items || getNavItems()).forEach(function (item) {
            item.setAttribute("aria-selected", "false");
            item.classList.remove("unx-nav-active");
        });
    }

    autosuggest.domService.inputBox.addEventListener("input", function () {
        currentNavIndex = -1;
        originalInputValue = this.value;
    });

    autosuggest.domService.inputBox.addEventListener("keydown", function (e) {
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault();
            let items = getNavItems();
            if (!items.length) return;

            if (currentNavIndex === -1) {
                originalInputValue = this.value;
            }

            if (e.key === "ArrowDown") {
                currentNavIndex = currentNavIndex < items.length - 1 ? currentNavIndex + 1 : 0;
            } else {
                currentNavIndex = currentNavIndex > 0 ? currentNavIndex - 1 : -1;
            }

            if (currentNavIndex === -1) {
                this.value = originalInputValue;
                clearNavActive(items);
            } else {
                applyNavActive(currentNavIndex, items);
            }
            return;
        }

        if (e.key === "Enter") {
            if (currentNavIndex >= 0) {
                let navItems = getNavItems();
                let activeItem = navItems[currentNavIndex];
                if (activeItem) {
                    let link = activeItem.querySelector("a[href]");
                    if (link) {
                        e.preventDefault();
                        e.stopPropagation();
                        currentNavIndex = -1;
                        window.location.href = link.href;
                        return;
                    }
                }
            }
            if (!this.value.trim()) {
                e.preventDefault();
                e.stopPropagation();
            }
        }

        if (e.key === "Escape") {
            currentNavIndex = -1;
            this.value = originalInputValue;
            clearNavActive();
        }
    });

    let searchForm = autosuggest.domService.inputBox.closest("form");
    if (searchForm) {
        searchForm.addEventListener("submit", function (e) {
            let inputEl = autosuggest.domService.inputBox;
            if (inputEl && !inputEl.value.trim()) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, true);
    }

    let searchBtn = autosuggest.domService.inputBox.closest("form")
        ? autosuggest.domService.inputBox.closest("form").querySelector(".search__button")
        : null;
    if (searchBtn) {
        searchBtn.addEventListener("click", function (e) {
            let inputEl = autosuggest.domService.inputBox;
            if (inputEl && !inputEl.value.trim()) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, true);
    }

    let origUnmount = autosuggest.domService.unmountAutosuggestionBox.bind(autosuggest.domService);
    autosuggest.domService.unmountAutosuggestionBox = function () {
        if (Date.now() - lastFocusTimeGlobal < 200) {
            return;
        }
        origUnmount();
    };

    (function waitForInitialData() {
        let attempts = 0;
        let maxAttempts = 40;
        let intervalId = setInterval(function () {
            attempts++;
            let state = autosuggest.stateManager.getState() || {};
            let resp = state.response || {};
            let ip = resp.initialRequestProducts;
            let hasData = Array.isArray(ip) ? ip.length > 0
                : (ip && typeof ip === "object" && Object.values(ip).some(function (arr) { return Array.isArray(arr) && arr.length > 0; }));
            if (hasData) {
                clearInterval(intervalId);
                initialDataReady = true;
                let input = autosuggest.domService.inputBox;
                let isInputVisible = input && input.offsetParent !== null;
                let isInputFocused = input && (document.activeElement === input ||
                    input.closest("[open]") || input.closest(".active"));
                if (isInputVisible && isInputFocused) {
                    customRenderSuggestions();
                }
            }
            if (attempts >= maxAttempts) clearInterval(intervalId);
        }, 250);
    })();

    document.addEventListener("mousedown", function (event) {
        if (event.target.closest(".unx-autosuggest-box")) {
            event.preventDefault();
        }
    });

    window.__unbxdAutosuggest = autosuggest;

    autosuggestBoundInput = document.querySelector(searchInput);
    isAutosuggestInitialized = true;
    console.log("[Unbxd Autosuggest] Initialized on", searchInput);
    return true;
}

function initAutosuggestWithRetry(attempt) {
    let maxAttempts = 60;
    if (initAutosuggest()) return;
    if (attempt >= maxAttempts) return;
    setTimeout(function () {
        initAutosuggestWithRetry(attempt + 1);
    }, 250);
}

document.addEventListener("focusin", function (event) {
    if (!event.target.matches || !event.target.matches(getSearchInputSelector())) return;
    if (isAutosuggestInitialized && autosuggestBoundInput === event.target) return;

    document.querySelectorAll("[" + activeInputAttr + "]").forEach(function (el) {
        el.removeAttribute(activeInputAttr);
    });
    event.target.setAttribute(activeInputAttr, "true");

    if (window.__unbxdAutosuggest) {
        try {
            let oldBox = document.querySelector(".unx-autosuggest-box");
            if (oldBox && oldBox.parentNode) oldBox.remove();
        } catch (e) {}
    }

    isAutosuggestInitialized = false;
    autosuggestBoundInput = null;

    initAutosuggest();
    if (!isAutosuggestInitialized) return;

    let retryCount = 0;
    let retryId = setInterval(function () {
        retryCount++;
        if (!event.target || document.activeElement !== event.target || retryCount > 15) {
            clearInterval(retryId);
            return;
        }
        let box = document.querySelector(".unx-autosuggest-box");
        if (box && box.parentNode) {
            clearInterval(retryId);
            return;
        }
        event.target.dispatchEvent(new Event("focus"));
    }, 200);
});

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
        initAutosuggestWithRetry(0);
    });
} else {
    initAutosuggestWithRetry(0);
}

